/* eslint-disable prettier/prettier */
import React, { FC } from 'react';

import Helmet from 'react-helmet';

import { useIsClient } from '@crehana/react-hooks';

import getCountryPrefix from 'Utils/getCountryPrefix';


type CourseListProps = {
  courses?: Array<{
    title: string;
    description: string;
    url: string;
    originalId: number;
    modifiedDate: string;
    launchDate: string;
    score: {
      average: number;
      total: number;
    };
    professor?: {
      fullName: string;
      profilePictureUrl: string;
    };
    category?: {
      name: string;
    };
    categoryObj?: {
      name: string;
    };
  }>;
};

const CourseList: FC<CourseListProps> = ({ courses }) => {
  const isClient = useIsClient();

  if (
    !isClient ||
    !courses ||
    !Array.isArray(courses) ||
    courses.length === 0
  ) {
    return null;
  }

  const getContent = () => {
    return {
      '@context': 'http://schema.org/',
      '@type': 'ItemList',
      itemListElement: courses.map((course, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Course',
          name: course.title,
          description: course.description,
          dateModified: course.modifiedDate,
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: course.score.average.toString(),
            ratingCount: (course.score.total === 0
              ? 1
              : course.score.total
            ).toString(),
          },
          url: `${window.location.origin}${window.location.pathname}#course-item-${course.originalId}`,
          keywords: (course.category || course.categoryObj)?.name || '',
          author: course.professor
            ? {
                '@type': 'Person',
                name: course.professor.fullName,
                image: course.professor.profilePictureUrl,
              }
            : undefined,
          provider: {
            '@context': 'http://schema.org/',
            '@type': 'Organization',
            name: 'CREHANA',
            logo: 'https://static.crehana.com/static/img/apple-touch-icon-120.0ebc9eb1389a.png',
            url: `https://www.crehana.com/${getCountryPrefix()}/`,
          },
          dateCreated: course.launchDate,
          copyrightYear: new Date(course.launchDate).getFullYear(),
        },
      })),
    };
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(getContent())}</script>
    </Helmet>
  );
};

export default CourseList;
